<template>   
  <dialog-layout  ref="imageDialog" id="imageDialog" @click="dialogActions">
      <span v-if="image">        
        <template slot="headercontent">{{image.title}}</template> 
        <img  :src="image.url" width="100%" class="w3-image"/>                
        <slot :image="image"></slot>
      </span>
      

  </dialog-layout>   
</template>


<script>
  import moment from 'moment'
  export default {    
    data: function() {
      return {        
        image:null
      }
    },
    methods: {  
      show(image){
          this.image=image
          this.$refs.imageDialog.show()
      },
      dialogActions(e){
        if(e.action==="canceldialog")
        {
          this.image=null
        }        
      },
      cancelDialog() {           
          this.$refs.imageDialog.cancelDialog()          
      }

    }    
  };
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/ImageDialog.vue